import { useQuery } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import type { PropertyDetail } from "./types";
import { PROPERTY_DETAIL_QUERY_KEY } from "./constants";

/**
 * Hits `GET /api/admin/properties/:id` (API-1.20) — the admin detail
 * endpoint that includes the owner block. Hand-written `httpClient`
 * call — see CLAUDE.md → TD-07.
 */
async function fetchPropertyDetail(id: string): Promise<PropertyDetail> {
  return httpClient<PropertyDetail>(`/api/admin/properties/${encodeURIComponent(id)}`);
}

export function usePropertyDetail(id: string | undefined) {
  return useQuery({
    queryKey: [...PROPERTY_DETAIL_QUERY_KEY, id] as const,
    queryFn: () => {
      if (!id) throw new Error("usePropertyDetail requires an id");
      return fetchPropertyDetail(id);
    },
    enabled: Boolean(id),
    staleTime: 30_000,
  });
}
